import {Directive, ElementRef, Input, Renderer2} from "@angular/core";
import {CachedImageService} from "./cached-image.service";
import {FedeltaImageData} from "@fedelta-pos/data-client";

@Directive({
    selector: "[woa-image-cache]"
})
/**
 * Directive to load an image using the ImageService
 */
export class ImageCacheDirective {
    private _imageData: FedeltaImageData;

    constructor(private element: ElementRef,
                private renderer: Renderer2,
                private imageService: CachedImageService) {
    }

    get imageData(): FedeltaImageData {
        return this._imageData;
    }

    @Input("woa-image-cache")
    set imageData(value: FedeltaImageData) {
        this._imageData = value;

        this.renderer.removeClass(this.element.nativeElement, "cached-image-loaded");
        this.renderer.removeClass(this.element.nativeElement, "cached-image-loading");
        this.renderer.removeClass(this.element.nativeElement, "cached-image-none");

        if (value && value.image) {
            this.element.nativeElement.src = "data:image;base64," + value.image;
            this.renderer.addClass(this.element.nativeElement, "cached-image-loaded");
            this.renderer.removeClass(this.element.nativeElement, "cached-image-loading");
        } else if (value && value.id) {
            this.renderer.addClass(this.element.nativeElement, "cached-image-loading");
            (async () => {
                try {
                    this.element.nativeElement.src = "data:image;base64," + await this.imageService.getImage(value.id, value.hash);
                    this.renderer.addClass(this.element.nativeElement, "cached-image-loaded");
                    this.renderer.removeClass(this.element.nativeElement, "cached-image-loading");
                } catch (error) {
                    this.element.nativeElement.src = "";
                    this.element.nativeElement.alt = "";
                }
            })();
        } else {
            this.element.nativeElement.src = "";
            this.element.nativeElement.alt = "";
            this.renderer.addClass(this.element.nativeElement, "cached-image-none");
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/image/image-cache.directive.ts